import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=cfa5f0f4&scoped=true"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"
import style0 from "./step6.vue?vue&type=style&index=0&id=cfa5f0f4&prod&lang=css"
import style1 from "./step6.vue?vue&type=style&index=1&id=cfa5f0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5f0f4",
  null
  
)

export default component.exports